import Image from "next/image";
import { useIntl } from "react-intl";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import {
  addBasePathToStrapiMedia,
  formatStrapiEntity,
  StrapiEntity,
  StrapiImage,
} from "@/utils/strapi";
import { defaultImageQuality } from "@/const/imageQuality";
import styles from "./DefaultPresentation.module.scss";

export type DefaultPresentationProps = {
  title?: string;
  image?: StrapiEntity<StrapiImage>;
  text?: string;
  name: string;
};

export const DefaultPresentation = ({
  title,
  image,
  text,
  name,
}: DefaultPresentationProps) => {
  const intl = useIntl();
  const nameReplacer = (template: string) =>
    template.replace(/\{name\}/gi, name);

  return (
    <div className={styles.container}>
      {title !== undefined && (
        <h2
          className={styles.title}
          dangerouslySetInnerHTML={injectPurifiedHTML(
            removeEmptyRel(nameReplacer(title))
          )}
        />
      )}
      {image?.data && (
        <div className={styles.imageContainer}>
          <Image
            width={816}
            height={380}
            layout="fixed"
            objectFit="contain"
            src={addBasePathToStrapiMedia(formatStrapiEntity(image))}
            alt={intl.formatMessage(
              { id: "pointOfInterestListAlternativeText" },
              { location: name }
            )}
            quality={defaultImageQuality}
          />
        </div>
      )}
      {text !== undefined && (
        <div
          className={styles.text}
          dangerouslySetInnerHTML={injectPurifiedHTML(
            removeEmptyRel(nameReplacer(text))
          )}
        />
      )}
    </div>
  );
};
